

export class BMIdRequest {
    bmId: number;
    username: string;

    /**
     * 
     * @param bmId 
     * @param username 
     */
    constructor(bmId: number, username: string) {
        this.bmId = bmId;
        this.username = username;
    }
}